import { useTranslation } from "react-i18next";
import { useStyles } from "./basketStyles";
import { Badge, Button } from "@mui/material";
import { ShoppingCartOutlined as ShoppingBasket } from "@mui/icons-material";
import { useEffect, useState } from "react";
import _ from "lodash";
import { ELEMENT_ID } from "utils/constants";
import { ProductBasket } from "store/bookingJourney";

type BasketProps = {
  isMobileView: boolean;
  onClick?: (event: any) => void;
  products: ProductBasket[];
};
export const Basket: React.FC<BasketProps> = ({ isMobileView, onClick, products }) => {
  const { t } = useTranslation();
  const [basketQuantity, setBasketQuantity] = useState<number>(0);
  useEffect(() => {
    setBasketQuantity(_.sumBy(products, (p) => p.quantity));
  }, [products]);
  const classes = useStyles();
  return (
    <>
      {isMobileView ? (
        <>
          <Badge
            className={classes.basketMobile}
            id={ELEMENT_ID.MOBILE + "-" + ELEMENT_ID.BASKET}
            badgeContent={basketQuantity}
            classes={{ badge: classes.basketBadgeMobile }}
          >
            <ShoppingBasket />
          </Badge>
          {t("basket")}
        </>
      ) : (
        <Button
          className={classes.basket}
          id={ELEMENT_ID.BASKET}
          onClick={onClick}
          aria-labelledby={ELEMENT_ID.BASKET + "-badge"}
        >
          <Badge
            badgeContent={basketQuantity}
            aria-hidden="true"
            classes={{ badge: classes.basketBadge }}
            slotProps={{
              badge: {
                "aria-label": `${t("basket")} ${t("quantity")} ${basketQuantity}`,
                id: ELEMENT_ID.BASKET + "-badge",
              },
            }}
          >
            <ShoppingBasket aria-hidden="true" />
          </Badge>
        </Button>
      )}
    </>
  );
};
